import React from 'react'
import { TermsAndConditionsMetaProps } from '../../data/types'
import { Button, Modal } from '.'

type Props = {
    isOpen: boolean
    onClose: () => void
    meta: TermsAndConditionsMetaProps
}

export const ViewTermsModal = (props: Props) => {
    const { isOpen, onClose, meta } = props

    const footer = (
        <div className="flex justify-end">
            <Button
                onClick={onClose}
                color='primary'
            >
                Close
            </Button>
        </div>
    )

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={meta.title}
            footer={footer}
            maxWidth="2xl"
            showCloseButton={true}
        >
            <div className="px-6 py-6 max-h-[60vh] overflow-y-auto">
                <div className="prose dark:prose-invert max-w-none">
                    {meta.content.split('\n\n').map((paragraph, index) => {
                        const parts = paragraph.match(/^(\*\*[^*]+\*\*):?\s*(.*)$/)

                        // Extract the bold title and content
                        if (parts) {
                            const [, title, content] = parts
                            const [, titleText] = title.split('**')
                            return (
                                <div key={index} className="mb-4">
                                    <p className="font-semibold text-gray-900 dark:text-gray-100 mb-1">
                                        <strong>{titleText.replace(/\*\*/g, '')}</strong>
                                    </p>
                                    <p className="text-gray-700 dark:text-gray-300 ms-6">
                                        {content.trim().split('\\n').map((line, i) => (
                                            <React.Fragment key={i}>
                                                {line}
                                                {i < content.trim().split('\\n').length - 1 && <br />}
                                            </React.Fragment>
                                        ))}
                                    </p>
                                </div>
                            )
                        }

                        // Regular paragraph
                        return (
                            <p key={index} className="text-gray-700 dark:text-gray-300 mb-4">
                                {paragraph}
                            </p>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
